var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"pa-3"},[_vm._v("\n  Developed with \n  "),_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("fas fa-heart")]),_vm._v(" and \n  "),_c('v-icon',{attrs:{"small":"","color":"green"}},[_vm._v("fab fa-vuejs")]),_c('v-spacer'),_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear()))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }